var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"color":("white--text " + _vm.colorByInterval)}},[_vm._v("\n  "+_vm._s(_vm.textByInterval)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }